<template>
  <div
    class="preview-box"
    @click="openLink(options.link)"
  >
    <div
      v-if="options.preview &amp;&amp; options.preview.image"
      class="preview-box__image"
    >
      <img
        :src="options.preview.image"
        :alt="options.preview.title"
      >
    </div>
    <div
      v-if="options.preview &amp;&amp; options.preview.altImage"
      class="preview-box__image"
    >
      <img
        src="../../assets/img/chatbot/whitelabel/community-bkg@3x.png"
        alt="img"
      >
    </div>
    <div
      v-if="options.preview &amp;&amp; options.preview.title"
      class="preview-box__title"
    >
      {{ options.preview.title }}
    </div>
    <div
      v-if="options.preview &amp;&amp; options.preview.description"
      class="preview-box__description"
    >
      {{ options.preview.description }}
    </div>
    <div
      v-if="options &amp;&amp; options.link"
      class="preview-box__link"
    >
      {{ options.link | getDomain }}
    </div>
  </div>
</template>


<script>

const community = require("../../assets/img/chatbot/whitelabel/community-bkg@3x.png");

export default {
    name: "PreviewLink",
    filters: {
        getDomain: function (value) {
            if (!value) return "";
            value = value.toString().split("://")[1].split("/")[0];
            return value;
        },
    },
    props: ["options",],
    data() {
        return {};
    },
    methods: {
        openLink(link) {
            window.open(link);
        },
    },
};
</script>

<style lang="scss">
    @import "../../assets/styles/scss/chatbot/commons";

    .preview-box {
        @include e('image') {
            margin: -17px -17px 15px -17px;
            border-radius: 25px 25px 0 0;
            overflow: hidden;
            img {
                width: 100%;
            }
        }
        @include e('title') {
            font-size: 14px;
            margin: 5px 0 10px;
        }
        @include e('description') {
            font-size: 13px;
            font-family: $font-book;
            color: #666;
            margin: 5px 0;
            line-height: 18px;
        }
        @include e('link') {
            display: inline-block;
            margin: 5px 0 5px;
            text-decoration: none;
            font-size: 13px;
            color: #b2b2b2;
            font-family: $font-medium;
        }
    }
</style>
